import { render } from "./reportTable.vue?vue&type=template&id=dbab65ac&scoped=true"
import script from "./reportTable.vue?vue&type=script&lang=js"
export * from "./reportTable.vue?vue&type=script&lang=js"

import "./reportTable.vue?vue&type=style&index=0&id=dbab65ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbab65ac"]])

export default __exports__